module.exports = __webpack_public_path__ + "themes/mf/img/logo-title@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/logo-title@2x.png
// module id = 13
// module chunks = 3 4